import { render, staticRenderFns } from "./InfoModules.vue?vue&type=template&id=1a58b744&scoped=true&"
import script from "./InfoModules.vue?vue&type=script&lang=js&"
export * from "./InfoModules.vue?vue&type=script&lang=js&"
import style0 from "./InfoModules.vue?vue&type=style&index=0&id=1a58b744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58b744",
  null
  
)

export default component.exports